import React from 'react'
import clsx from 'clsx'
import ParagraphWidget from 'components/set/ParagraphWidget/ParagraphWidget'
import BuyWidget from 'components/set/BuyWidget/BuyWidget'
import useStyles from './styles'
import { WidgetContent, WidgetType, WidgetLinkType } from 'data/Show'
import WidgetLinks from 'components/set/WidgetLinks/WidgetLinks'
import { useSelector } from 'react-redux'
import { getCurtainValue } from 'redux/slices/curtain'
import { SOCIAL_URL } from 'constants.js'
import TributeWidget from 'components/set/TributeWidget/TributeWidget'
import { isCurtainOpen, isCurtainClosed } from 'utils/curtain'
import { getShowWidgets } from 'redux/slices/liveShow'
import { isPopulatedArray } from 'utils/populated'
interface WidgetContainerProps {
    hideInMobile?: boolean
}
interface WidgetProvider {
    [key: string]: (key: number, props: WidgetContent) => React.ReactNode
}
const widgetsProvider: WidgetProvider = {
    [WidgetType.BUY]: (key, props) => (
        <BuyWidget
            key={key}
            heading={props.heading}
            subHeading={props.subHeading!}
            hyperlink={props.hyperlink!}
            items={props.items!}
        />
    ),
    [WidgetType.PARAGRAPH]: (key, props) => <ParagraphWidget key={key} heading="About The Event" body={props.body!} />,
}
const CadenzaLinksWidget: React.FC = React.memo(() => {
    const widget = {
        type: WidgetType.LINKS,
        content: {
            heading: 'Follow Novel',
            links: [
                {
                    linkUrl: SOCIAL_URL.INSTAGRAM,
                    type: WidgetLinkType.INSTAGRAM,
                },
                {
                    linkUrl: SOCIAL_URL.FACEBOOK,
                    type: WidgetLinkType.FACEBOOK,
                },
                {
                    linkUrl: SOCIAL_URL.TWITTER,
                    type: WidgetLinkType.TWITTER,
                },
            ],
        },
    }
    return <WidgetLinks widget={widget} />
})
const WidgetContainer: React.FC<WidgetContainerProps> = ({ hideInMobile = false }) => {
    const classes = useStyles()
    const showWidgets = useSelector(getShowWidgets)!
    const widgets = isPopulatedArray(showWidgets) ? showWidgets : []
    const curtainValue = useSelector(getCurtainValue)
    const socialLinks = widgets.filter(widget => widget.type === WidgetType.LINKS)
    const otherWidgets = widgets.filter(widget => widget.type !== WidgetType.LINKS)
    const curtainOpen = isCurtainOpen(curtainValue)
    const curtainClosed = isCurtainClosed(curtainValue)

    return (
        <section
            className={clsx(classes.container, {
                [classes.hideInMobile]: hideInMobile,
            })}
        >
            {!!widgets.length && (
                <div
                    className={clsx(classes.wideColumn, {
                        [classes.fullWidth]: !socialLinks.length && curtainOpen,
                    })}
                >
                    {otherWidgets.map((widget, i) => widgetsProvider[widget.type](i, widget.content))}
                    {curtainClosed && (
                        <div className={clsx(curtainClosed && classes.animateTribute)}>
                            <TributeWidget />
                        </div>
                    )}
                </div>
            )}
            {!!socialLinks.length && (
                <div
                    className={clsx(classes.narrowColumn, {
                        [classes.fullWidth]: !widgets.length,
                    })}
                >
                    {socialLinks.map((widget, i) => (
                        <div key={i} className={clsx(!curtainOpen && classes.animateWidgetLinks)}>
                            <WidgetLinks widget={widget} key={i} />
                        </div>
                    ))}
                    {!curtainOpen && (
                        <div className={classes.animateCadenzaLinks}>
                            <CadenzaLinksWidget />
                        </div>
                    )}
                </div>
            )}
        </section>
    )
}
export default React.memo(WidgetContainer)
